import moment from "moment";
import MaskService from "../../../utils/mask/maskService";
import { initialFilters, reportTypes } from "../constants";

export const categorizedReleases = {
  "Somente categorizados": "categorized",
  "Somente não categorizados": "notCategorized",
  Todos: "all",
};

export const accountingSystems = {
  Competência: "competence",
  Caixa: "cash",
};

export const detailedColumns = [
  {
    label: "Categoria do Financeiro",
    id: "categoryDescription",
    format: (_) => "",
    minWidth: 180,
  },
  {
    label: "Empresa",
    id: "company",
  },
  {
    label: "Descrição",
    id: "description",
    format: (item) => item ?? "Sem descrição",
  },
  {
    label: "Documento",
    id: "document",
  },
  {
    label: "Data",
    id: "date",
    format: (item) => moment(item, "YYYY-MM-DD").format("DD/MM/YYYY"),
  },
  {
    label: "Competência",
    id: "competency",
  },
  {
    label: "Situação",
    id: "status",
  },
  {
    label: "Débito (R$)",
    id: "debit",
    align: "right",
    minWidth: 100,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "%",
    id: "debitPerCent",
    align: "left",
    format: (item) => item ?? 0,
    minWidth: 40,
  },
  {
    label: "Crédito (R$)",
    id: "credit",
    align: "right",
    minWidth: 100,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "%",
    id: "creditPerCent",
    align: "left",
    minWidth: 40,
    format: (item) => item ?? 0,
  },
];

export const consolidatedColumns = [
  {
    label: "Categoria do Financeiro",
    id: "categoryDescription",
    format: (item) => "",
    minWidth: 700,
  },
  {
    label: "Débito (R$)",
    id: "debit",
    align: "right",
    minWidth: 80,
    format: (item) => {
      return `${item < 0 ? " - " : ""} ${MaskService.toMask(
        "decimal",
        parseFloat(item ?? "0,00").toFixed(5),
        5
      )}`;
    },
  },
  {
    label: "%",
    id: "debitPerCent",
    align: "left",
    format: (item) => item ?? 0,
    minWidth: 50,
  },
  {
    label: "Crédito (R$)",
    id: "credit",
    align: "right",
    minWidth: 80,
    format: (item) => {
      return `${MaskService.toMask(
        "decimal",
        parseFloat(item ?? "0,00").toFixed(5),
        5
      )}`;
    },
  },
  {
    label: "%",
    id: "creditPerCent",
    align: "left",
    minWidth: 50,
    format: (item) => item ?? 0,
  },
  {
    label: "Saldo (R$)",
    id: "balance",
    align: "right",
    minWidth: 50,
    format: (item) =>
      `${item < 0 ? " - " : ""} ${MaskService.toMask(
        "decimal",
        parseFloat(item ?? "0,00").toFixed(5),
        5
      )}`,
  },
];

export const reInitialFilters = {
  period: initialFilters.period,
  startDate: initialFilters.startDate,
  endDate: initialFilters.endDate,
  showNotPayedAccounts: initialFilters.showNotPayedAccounts,
  showNotReceivedTitles: initialFilters.showNotReceivedTitles,
  multicompany: initialFilters.multicompany,
  groupByFinanceCategory: true,
  reportType: reportTypes.Consolidado,
  categorizedRelease: categorizedReleases.Todos,
  accountingSystem: accountingSystems.Competência,
};
